<template>
  <div class="chkpwd-box">
    <div class="header">{{$t('account.changePwd.title')}}</div>
    <Form ref="form" :model="form" :rules="ruleForm" @submit.native.prevent>
      <FormItem prop="oldPassword" class="pwd">
        <i class="form-icon pwd"></i>
        <Input type="password" v-model.trim="form.oldPassword" clearable @on-enter="ok" :placeholder="$t('account.changePwd.oldPwdPlaceholder')" />
      </FormItem>
      <FormItem prop="newPassword" class="pwd">
        <i class="form-icon pwd"></i>
        <Input type="password" v-model.trim="form.newPassword" clearable @on-enter="ok" :placeholder="$t('account.changePwd.newPwdPlaceholder')" />
      </FormItem>
      <FormItem prop="passwordRetry">
        <i class="form-icon pwdRetry"></i>
        <Input type="password" v-model.trim="form.passwordRetry" clearable @on-enter="ok" :placeholder="$t('account.changePwd.newPasswordRetry')" />
      </FormItem>
    </Form>
    <div class="footer">
      <Button type="primary" :loading="isShowLoader" @click="ok">
        <span v-if="!isShowLoader"><span>{{$t('btn.confirmed')}}</span></span>
        <span v-else>{{$t('btn.confirmed')}}</span>
      </Button>
    </div>
    <Loader :loadType="1" v-show="isShowLoader" class="black"></Loader>
  </div>
</template>

<script>
import Loader from '@/components/layout/Loader'
import { mapMutations } from 'vuex'

export default {
  name: 'ChangePasswordForm',
  components: { Loader },
  data () {
    const validatePass = (rule, value, callback) => {
      if (value !== '' && this.form.passwordRetry !== '' && value !== this.form.passwordRetry) {
        this.$refs.form.validateField('passwordRetry')
      }
      callback()
    }
    const validatePassCheck = (rule, value, callback) => {
      if (value !== '' && value !== this.form.newPassword) {
        callback(new Error(this.$t('account.reg.retryPwdNoMatch')))
      } else {
        callback()
      }
    }
    return {
      isSubmit: false,
      isShowLoader: false,
      form: {
        oldPassword: '',
        newPassword: '',
        passwordRetry: ''
      },
      ruleForm: {
        oldPassword: [
          { required: true, message: this.$t('account.changePwd.oldPwdPlaceholder'), trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: this.$t('account.changePwd.newPwdPlaceholder'), trigger: 'blur' },
          { type: 'string', min: 6, message: this.$t('account.reg.pwdMinLenMsg'), trigger: 'blur' },
          { validator: validatePass, trigger: 'blur' }
        ],
        passwordRetry: [
          { required: true, message: this.$t('account.changePwd.newPasswordRetry'), trigger: 'blur' },
          { validator: validatePassCheck, trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.$root.$on('clearFormCloseModal', () => {
        this.$refs['form'] && this.$refs['form'].resetFields()
      })
    })
  },
  methods: {
    ok () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.$Loading.start()
          this.isSubmit = true
          this.isShowLoader = true
          this.$api.account.chkPwd({
            oldPassword: this.form.oldPassword,
            newPassword: this.form.newPassword
          }, {
            success: (response) => {
              this.$Loading.finish()
              this.isSubmit = false
              this.isShowLoader = false
              if (response.data.code === 200) {
                this.setChkPwdModalState(false)
                this.$Message.success({content: this.$t('account.changePwd.chkPwdSuccess'), closable: true})
                this.$refs['form'].resetFields()
              } else if (response.data.code === 200205) {
                this.$Message.error({content: this.$t('account.changePwd.oldPwdError'), closable: true})
              } else {
                this.$Message.error({content: this.$t('account.changePwd.changeErrorAgain'), closable: true})
              }
            },
            error: (errorMsg) => {
              this.$Loading.error()
              this.isSubmit = false
              this.isShowLoader = false
              this.$Message.error({content: this.$t('account.changePwd.changeError'), closable: true})
            }
          })
        }
      })
    },
    ...mapMutations({
      setChkPwdModalState: 'account/setChkPwdModalState',
      setUserInfo: 'account/setUserInfo'
    })
  }
}
</script>
<style scoped>
  .form-icon.pwd{
    background-image: url("~@/assets/images/icons/account/pwd.png");
  }
  .form-icon.pwdRetry{
    background-image: url("~@/assets/images/icons/account/passwd_retry.png");
  }
  .footer{
    margin-top: 10px;
  }
  .ivu-form-item.pwd{
    margin-bottom: 15px;
  }
  .ivu-form-item.pwd.ivu-form-item-error{
    margin-bottom: 30px;
  }
  .chkpwd-box >>> .loading .wrap{
    top: 30%;
  }
</style>



// WEBPACK FOOTER //
// src/components/account/ChangePasswordForm.vue